import { addMonths, addYears, startOfYear } from "date-fns/fp";
import type { Connect, View } from "../uwc-datepicker";
import { connectSelection } from "../parts/selection";
import {
  classNames,
  create,
  createEventRegistrar,
  text,
} from "@hesxenon/prelude/Dom.js";
import { getMonthName } from "../format";
import { Events } from "../events";

const connectGrid: Connect = (datepicker, opts) => {
  const on = createEventRegistrar(datepicker, opts.disconnect);

  const createGrid = () => {
    const months = create("ul", { role: "grid" });

    const now = new Date();
    const start = startOfYear(datepicker.anchorDate);
    const end = addYears(1, start);

    let cursor = start;
    while (cursor < end) {
      const next = addMonths(1, cursor);
      const dataValue = cursor.toISOString();
      months.append(
        create(
          "li",
          {
            "data-value": dataValue,
            className: classNames({
              current: cursor <= now && now <= next,
            }),
          },
          [text(getMonthName(cursor, datepicker.locale, "long"))],
        ),
      );

      cursor = next;
    }

    return months;
  };

  let grid = createGrid();

  on(Events["anchor-dateChanged"], () => {
    grid.remove();
    grid = createGrid();
    datepicker.append(grid);
  });

  datepicker.append(grid);
};

export const monthView: View = {
  addOneUnit: addMonths(1),
  connect: (datepicker, opts) => {
    connectSelection(datepicker, {
      addPages: addYears,
      leapPages: 10,
      getStartOfPage: startOfYear,
      getLabel: (current) => String(current.getFullYear()),
      disconnect: opts.disconnect,
    });

    connectGrid(datepicker, opts);
  },
};
